<template>
  <div>
    <el-group-title title="合同财务信息">
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="163px"
          class="ccui-form demo-form-inline"
          :inline="true"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="所在省/国家：" prop="province">
                <el-input
                  v-model="form.province"
                  class="ccui-form-longInput"
                  placeholder="请输入所在省/国家"
                  clearable
                  maxlength="10"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所在市/城市：" prop="city">
                <el-input
                  v-model="form.city"
                  class="ccui-form-longInput"
                  placeholder="请输入所在市/城市"
                  clearable
                  maxlength="10"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="所在县：" prop="county">
                <el-input
                  v-model="form.county"
                  class="ccui-form-longInput"
                  placeholder="请输入所在县"
                  clearable
                  maxlength="10"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所在区域：" prop="deliverPlace">
                <el-input
                  v-model="form.deliverPlace"
                  class="ccui-form-longInput"
                  placeholder="请输入所在区域"
                  clearable
                  maxlength="10"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="计税方法编码：" prop="taxMethodCode">
                <el-input
                  v-model="form.taxMethodCode"
                  class="ccui-form-longInput"
                  placeholder="请输入计税方法编码"
                  clearable
                  maxlength="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="计税方法：" prop="taxMethod">
                <el-input
                  v-model="form.taxMethod"
                  class="ccui-form-longInput"
                  placeholder="请输入计税方法"
                  clearable
                  maxlength="50"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="发票类型编码：" prop="invoiceTypeCode">
                <el-input
                  v-model="form.invoiceTypeCode"
                  class="ccui-form-longInput"
                  placeholder="请输入发票类型编码"
                  clearable
                  maxlength="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="发票类型：" prop="invoiceType">
                <el-input
                  v-model="form.invoiceType"
                  class="ccui-form-longInput"
                  placeholder="请输入发票类型"
                  clearable
                  maxlength="50"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="合同份数/协议份数：" prop="contractNum">
                <el-input
                  v-model="form.contractNum"
                  class="ccui-form-longInput"
                  placeholder="请输入合同份数/协议份数"
                  clearable
                  maxlength="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="物资来源：" prop="materialSource">
                <el-input
                  v-model="form.materialSource"
                  class="ccui-form-longInput"
                  placeholder="请输入物资来源"
                  clearable
                  maxlength="50"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="物资来源编码：" prop="materialSourceCode">
                <el-input
                  v-model="form.materialSourceCode"
                  class="ccui-form-longInput"
                  placeholder="请输入物资来源编码"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="支付系数：" prop="payTheCoefficient">
                <el-input
                  v-model="form.payTheCoefficient"
                  class="ccui-form-longInput"
                  placeholder="请输入支付系数"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="预付款：" prop="prepayment">
                <el-input
                  v-model="form.prepayment"
                  class="ccui-form-longInput"
                  placeholder="请输入预付款"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="签订地点：" prop="signPlace">
                <el-input
                  v-model="form.signPlace"
                  class="ccui-form-longInput"
                  placeholder="请输入签订地点"
                  clearable
                  maxlength="200"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="对方联系人：" prop="contractPerson">
                <el-input
                  v-model="form.contractPerson"
                  class="ccui-form-longInput"
                  placeholder="请输入对方联系人"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="合同业务类型：" prop="businessType">
                <el-select
                  v-model="form.businessType"
                  class="ccui-form-longInput"
                  placeholder="请选择合同业务类型"
                >
                  <el-option label="物资" value="01"></el-option>
                  <el-option label="周转材" value="02"></el-option>
                  <el-option label="分包合同" value="03"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
export default {
  name: "pcFinance",
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        id: "",
        province: "",
        city: "",
        county: "",
        deliverPlace: "",
        taxMethodCode: "",
        taxMethod: "",
        invoiceTypeCode: "",
        invoiceType: "",
        contractNum: "",
        materialSource: "",
        materialSourceCode: "",
        payTheCoefficient: "",
        prepayment: "",
        partyBId: "",
        signPlace: "",
        contractPerson: "",
        businessType: "",
        contractId: ""
      },
      rules: {}
    };
  },
  watch: {
    dataInfo() {
      this.form = this.dataInfo;
    }
  }
};
</script>
